/**
 * ResetPasswordRequest
 * @author Simpli CLI generator
 */
import {$, Model, sleep} from 'simpli-web-sdk'
import {
  ValidationEmail,
  ValidationMaxLength,
} from 'simpli-web-sdk'

export default class ResetPasswordRequest extends Model {
  readonly $name: string = 'ResetPasswordRequest'

  @ValidationMaxLength(100)
  @ValidationEmail()
  email: string | null = null

  cnpj: string | null = null
}
